import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { Navigate, Route, Routes } from 'react-router-dom';

import AppTabs from '../../../components/designe/app-tabs/AppTabs';
import { supportBasePath } from './supportBasePath';
import { SupportRequestsList } from './SupportRequestsList';

export function SupportInnerTabs() {
  const { t } = useTranslation();
  const base = supportBasePath;

  const tabsConfig = useMemo(
    () => [
      {
        label: t('adminDashboard.support.tabs.active'),
        path: `${base}/active`,
      },
      {
        label: t('adminDashboard.support.tabs.archived'),
        path: `${base}/archived`,
      },
    ],
    [base, t],
  );

  return (
    <>
      <AppTabs config={tabsConfig} />
      <Box sx={{ mt: 2 }}>
        <Routes>
          <Route
            path="active"
            element={<SupportRequestsList archived={false} />}
          />
          <Route path="archived" element={<SupportRequestsList archived />} />
          <Route index element={<Navigate to="active" replace />} />
        </Routes>
      </Box>
    </>
  );
}
